<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Notifications'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Notifications',
            actions: [
                {
                    icon: 'far fa-eye',
                    method: 'read',
                    where: {
                        'notification2User[0].isRead': {
                            value: false
                        }
                    }
                }
            ]
        };
    },

    computed: {
        ...mapGetters({
            newRequest: 'notifications/newRequest'
        }),

        options() {
            return {
                addButton: false
            };
        },

        labels() {
            return [
                {
                    value: 'type.code',
                    filterFieldName: 'type.code',
                    width: '150px'
                },
                {
                    value: 'text',
                    width: '150px'
                },
                {
                    text: 'Is read',
                    value: 'notification2User[0].isRead',
                    filterFieldName: 'notification2User.isRead',
                    width: '150px',
                    type: 'boolean',
                    filter: val => (val ? 'Yes' : '-')
                },
                {
                    width: '200px',
                    text: 'Campus',
                    sortable: false,
                    value: 'request.user.campuses',
                    filterFieldName: 'request.user.campuses.name',
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'notifications/index',
            readNotification: 'notifications/read'
        }),

        async onRowClick(notification) {
            if (!notification.notification2User[0].isRead) {
                try {
                    await this.readNotification(notification.id);
                } catch (error) {
                    console.error(error);

                    this.$toasterError();
                }
            }

            if (notification.type.code === this.newRequest) {
                this.$router.push(
                    `/requests/${notification.notificationableId}/edit`
                );
            }
        },

        async read(id, index) {
            try {
                const notification = await this.readNotification(id);

                this.items.splice(index, 1, notification);

                this.$toaster('Notification has been read.');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
